import { createTheme } from '@mui/material/styles';
import { colors } from './colors';
import { componentOverrides } from './components';

export const theme = createTheme({
  palette: {
    primary: colors.primary,
    secondary: colors.secondary,
    success: colors.success,
    warning: colors.warning,
    error: colors.error,
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#1a1a1a',
      secondary: colors.custom.textSecondary,
    },
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
    h4: {
      fontWeight: 700,
      fontSize: '28px',
    },
    h5: {
      fontWeight: 600,
      fontSize: '24px',
    },
    h6: {
      fontWeight: 600,
      fontSize: '18px',
    },
    body1: {
      fontSize: '14px',
    },
    body2: {
      fontSize: '13px',
    },
  },
  shape: {
    borderRadius: 12,
  },
  spacing: 8, // Default spacing unit
  components: componentOverrides,
});

// Export colors for direct use in sx props
export { colors };